(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/*
    This file contains functions and variables that will be used sitewide on all js scripts
    This file should be loaded first in list
 */

/* Sets the screen width */
// window.screenwidth = jQuery(window).width(); //screenwidth
window.screenwidth = document.documentElement.clientWidth;

/*
    Function for getting current device based on width

    returns: (string), a character representing the device (m = mobile, d = desktop, t = tablet)
*/

window.getDevice = function () {
  var device;
  device = 'm';

  /* This decided what platform is being used depending on screensize and orientation */
  if (screenwidth > 991) {
    device = 'd'; //sets platform as desktop
  } else if (screenwidth <= 991 && screenwidth > 599) {
    device = 't'; //sets platform as tablet
  } else if (screenwidth <= 599) {
    device = 'm'; //sets platform as mobile
  } else {
    device = 'n';
  }
  return device;
};

/* For now we will have a variable for device but we should use the function */
window.device = window.getDevice();

/*
    Returns the value of a url parameter by giving it its name

    name: (string), the name of a url parameter

    returns: (string), the value of the parameter in string form
 */
window.getParameterByName = function () {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  // name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  // /*document.write("<br>#1 name = "+name);*/
  // var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
  //     results = regex.exec(location.search);
  // return results == null ? "" : results[1].replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '-');

  var url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

/*
    Checks if function exits - ie. if fbq isnt declared

    possibleFunction: (object), function itself to see if its a function

    returns: (bool), true if its a function and false if its not
 */
window.isFunction = function (function_name) {
  return _typeof(function_name) === (typeof Function === "undefined" ? "undefined" : _typeof(Function));
};

/*
    We use this function so that if function doesnt exist it doesnt
    crash the whole script

    function_name: (string), name of function we are checking
 */
window.runFunctionNameIfExists = function (function_name) {
  //check if function exists and if so run it
  if (typeof window[function_name] === "function") {
    window[function_name]();
  } else {
    console.log(function_name + '( )function doesnt exist');
  }
};

/*
    Checks if the dom is ready, equivalent of jQuery(document).ready() but vanilla js
 */
window.domReady = function (callback) {
  var ready = false;
  var detach = function detach() {
    if (document.addEventListener) {
      document.removeEventListener("DOMContentLoaded", completed);
      window.removeEventListener("load", completed);
    } else {
      document.detachEvent("onreadystatechange", completed);
      window.detachEvent("onload", completed);
    }
  };
  var completed = function completed() {
    if (!ready && (document.addEventListener || event.type === "load" || document.readyState === "complete")) {
      ready = true;
      detach();
      callback();
    }
  };
  if (document.readyState === "complete") {
    callback();
  } else if (document.addEventListener) {
    document.addEventListener("DOMContentLoaded", completed);
    window.addEventListener("load", completed);
  } else {
    document.attachEvent("onreadystatechange", completed);
    window.attachEvent("onload", completed);
    var top = false;
    try {
      top = window.frameElement == null && document.documentElement;
    } catch (e) {}
    if (top && top.doScroll) {
      (function scrollCheck() {
        if (ready) return;
        try {
          top.doScroll("left");
        } catch (e) {
          return setTimeout(scrollCheck, 50);
        }
        ready = true;
        detach();
        callback();
      })();
    }
  }
};
window.removeParam = function (key, sourceURL) {
  var rtn = sourceURL.split("?")[0],
    param,
    params_arr = [],
    queryString = sourceURL.indexOf("?") !== -1 ? sourceURL.split("?")[1] : "";
  if (queryString !== "") {
    params_arr = queryString.split("&");
    for (var i = params_arr.length - 1; i >= 0; i -= 1) {
      param = params_arr[i].split("=")[0];
      if (param === key) {
        params_arr.splice(i, 1);
      }
    }
    rtn = rtn + "?" + params_arr.join("&");
  }
  return rtn;
};
window.removeParamsArray = function (keys, sourceURL) {
  if (typeof sourceURL !== 'string' || !Array.isArray(keys) || keys.length === 0) {
    console.error('Invalid input: sourceURL must be a string and keys must be a non-empty array');
    return sourceURL; // Return the original URL as a fallback
  }
  var rtn = sourceURL.split("?")[0],
    params_arr = [],
    queryString = sourceURL.indexOf("?") !== -1 ? sourceURL.split("?")[1] : "";
  if (queryString !== "") {
    params_arr = queryString.split("&");
    params_arr = params_arr.filter(function (param) {
      var currentKey = decodeURIComponent(param.split("=")[0]);
      return keys.indexOf(decodeURIComponent(currentKey)) === -1;
    });
    if (params_arr.length > 0) {
      rtn += "?" + params_arr.join("&");
    }
  }
  return rtn;
};

/*
    Returns the url without the initial www.metaspoon.com and a couple of variables removed such as utm_soutce and fbclid
    in order to shorten url. Used for returning to advertising platforms.

    returns: (string), a shortened version of the url and parameters
 */
window.getUtm = function () {
  var partUrl = window.location.pathname + location.search;
  var newURL = removeParam("utm_source", removeParam("fbclid", partUrl));
  return encodeURIComponent(newURL);
};

/*
    Returns the url with a couple of variables removed such as utm_soutce and fbclid
    in order to shorten url. Used for returning to advertising platforms.

    returns: (string), a shortened version of the url and parameters
 */
window.getUtmFullUrlEncoded = function () {
  var newURL = removeParam("utm_source", removeParam("fbclid", window.location.href));
  return encodeURIComponent(newURL);
};

/*
    Function for getting current platform based on fb URL.
    Looks for the 10th digit in the fbURL and returns that
    NOTE: it only works if we pass the normal fb variable name: 12345M2n2w
    It wont work if we pass a random

    returns: (string), a character representing the platform (y = android, d = desktop, i = iphone, etc)
    returns 'na' if there is none
*/

window.getPlatformFromFBVar = function () {
  var platform;
  var fb = getParameterByName('fb'); //y is android and w is iphone
  if (fb != null) platform = fb.substring(9, 10);
  if (platform === '' || platform == undefined) return 'na'; //if there is no fb or fb is not long enough to have a platform then return underfined

  return platform;
};

/* The platform ie. android, iphone, etc from the fb variable in url */
window.platformFromFbVar = window.getPlatformFromFBVar();

/*
    Get the debug parameter from url to show debugging on the site   - if set to debug=1 then it will show debugging
 */
window.debugMTS = window.getParameterByName('debug');

/*
    Function to launch modal in bootsrap
 */
/*
    General function for lanuching a bootstrap modal

    modal: (string), the html for the modal to show
    modal_id: (string), the id of the modal
 */
window.mtsLaunchModal = function (modal_id, content, title) {
  console.log('XXXXXXXXXXXXX in window.launchmodal');
  var modal = "\n            <div class=\"modal fade\" id=\"".concat(modal_id, "\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"").concat(modal_id, "\" aria-hidden=\"true\">\n                <div class=\"modal-dialog modal-dialog-centered\" role=\"document\">\n                    <div class=\"modal-content\">\n                        <div class=\"modal-header\">\n                            <div class=\"row\">\n                                <div style=\"height:40px;\"><img src=\"/wp-content/uploads/site-images/metaspoon_logo_square.png\" class=\"mr-2 ml-3\" style=\"width:40px;height:40px;\"></div>\n                                <h5 class=\"modal-title align-self-center\" id=\"exampleModalLongTitle\">\n                                     ").concat(title, "\n                                </h5>\n                            </div>\n                            <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                                <span aria-hidden=\"true\">&times;</span>\n                            </button>\n                        </div>\n                        <div class=\"modal-body\">\n                            ").concat(content, "\n                        </div>\n                    </div>\n                </div>\n            </div>\n        ");

  /*
         If modal html hasnt been added to the page yet then add it
      */
  if (!$("#".concat(modal_id)).length) {
    //add modal text to the html
    $('body').prepend(modal);
  }

  //open the modal
  $("#".concat(modal_id)).modal('show');

  /*
      Add event to delete modal when closed/hidden that way when a modal is opened again it will be fresh and not have old datya
   */
  $("#".concat(modal_id)).on('hidden.bs.modal', function (e) {
    $("#".concat(modal_id)).remove();
  });
};
/*
    A/B Testing script, should be in header and should first thing because
    we need to redirect people to correct url, so should be first in gulp

    Set it to ON or OFF From first variable

 */
//need to turn this value to "on" to run it
var runABTest = /*#__PURE__*/function () {
  function runABTest() {
    _classCallCheck(this, runABTest);
    console.log('Running ab tester');
    /*
        User set variables for experiement below
     */
    this.testSpecificDevices = true; //if set to true will only test specific devices, otherwise will run on all
    this.devicesToTest = ['d', 'm', 't'].map(function (v) {
      return v.toLowerCase();
    }); //can be ['d','m','t']
    this.testSpecificPlatforms = true; //if set to true will only test specific platforms otherwise will run on all (ie. 'y', 'w', etc) - iphone, android, etc
    this.platformsToTest = ['y', 'w', 'i', 'u', 'd'].map(function (v) {
      return v.toLowerCase();
    }); //can be ['y','w','i','u','d']
    // this.variations = ['ex1','nr1','ap1','np1'].map(v => v.toLowerCase()); //the variations we will be running in the url
    this.trafficPercentagePerVariation = {
      'cl1': 50,
      'nl1': 50
      // 'ap1' : 5,
      // 'ap2' : 5,
      // 'cl1' : 1,
      // 'cr1' : 1,
      // 'wst' : 5,
    }; //the percentage of total traffic each variation will get at random from qualigying traffic (ie. '10' means each variation gets 10% of total traffic)

    this.testAtCampaignLevel = true; //if set to true will only run tests on traffic on specified campaigns in this.campaignsToTest variable (true or false)
    this.campaignstoTest = ["99999m2", "16746m1", "19667m2"].map(function (v) {
      return v.toLowerCase();
    }); //the campaigns on which A/B test will occur - all converted to lower case
    this.testAtLongFormOnly = false; //if set to true, will only run A/B test on long form articles

    //edit the base path as opposed just parameters
    //ie. metaspoon.com/{added_base_path.some_var}/article-name
    this.addPathsToUrl = true;
    this.added_base_paths = {
      'cl1': 'cl' //cloud layout experiment
    };

    //create variatoins object ie. ['ex1','nr1'] based onf traffic percentage per variation object
    this.variations = [];
    for (var _i = 0, _Object$entries = Object.entries(this.trafficPercentagePerVariation); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];
      this.variations.push(key.toLowerCase());
    }

    //sets all url params to this.params variable
    this.setParams();

    //set test values like platform, current campaign, etc
    this.currentIsLongform = this.isLongFormWithFB();
    this.currentCampaign = typeof this.params.fb !== 'undefined' ? this.params.fb.substr(0, 7).toLowerCase() : ''; //the campaign ad id such as 12345M2 (first 7 characters of fb=) and convert to lowercase
    this.device = device.toLowerCase();
    this.platformFromFbVar = platformFromFbVar.toLowerCase();

    //set params from tv var
    this.tv_var = {
      platform: typeof this.params.tv !== 'undefined' ? this.params.tv.split('-')[0] : '',
      platform_p2: typeof this.params.tv !== 'undefined' ? this.params.tv.split('-')[1] : '',
      code: typeof this.params.tv !== 'undefined' ? this.params.tv.split('-')[2] : ''
    };

    /*
         If param force=1 it will force the experiment to show up 100 of the time
         by making each of the variations show up equally adding up to 100%
     */
    if (typeof this.params.force !== 'undefined') {
      if (this.params.force === '1' || this.params.force === 1) {
        console.log('force is 1, forcing a/b test');
        // this.trafficPercentagePerVariation = 50;
        var variation_num = this.variations.length;
        var percent_per_variation = 100 / variation_num;
        for (var i = 0; i < variation_num; i++) {
          this.trafficPercentagePerVariation[this.variations[i]] = percent_per_variation;
        }
        console.log('this.trafficPercentagePerVariation', this.trafficPercentagePerVariation);
      }
    }
    if (window.debugMTS === "1") {
      console.log('currentIsLongform:', this.currentIsLongform);
      console.log('currentCampaign:', this.currentCampaign);
      console.log('device:', this.device);
      console.log('platformFromFbVar:', this.platformFromFbVar);
    }

    //test if current A/B test conditions match
    var test_conditions_match = this.runTestConditions();

    //if test conditions match then add tv variable to the url
    if (test_conditions_match) this.setTestVar(window.location.href, window.location.search);

    //if they don't match AND we there is a TV var set, remove it
    else if (typeof this.params.tv !== 'undefined') this.removeExistingTestVar();
  }

  /*
      Adds the test variable to the url
   */
  return _createClass(runABTest, [{
    key: "setTestVar",
    value: function setTestVar(urlToLoad, queryStr) {
      var _self = this;

      /*
          If we have an existing test var then do the following:
            1- check if the current test var fits the current platform/device and experiement codes. If it does just return and dont do anything
          2- if it doesnt fit the current experiment then remove the tv code from the UrlToLoad variable and continue with experiement
       */
      if (typeof this.params.tv !== 'undefined') {
        if (this.doesCurrentTvCodeMatch(this.params.tv) == true) return; //if current code fits device/platform and experiment then exit
        else urlToLoad = removeParam('tv', urlToLoad); //otherwise remove the tv var and continue with the experiment
      }

      /*
          Pick the winning variation and create the tv variable to add to the url
          and if not successfull then dont run test
       */
      var variation_chosen = _self.getWinningVariation();
      if (variation_chosen === false) {
        if (window.debugMTS === "1") {
          console.log('Test not running - dice roll unsuccesful.');
        }
        return;
      }

      /*
          Pick the winning variation and create the tv variable to add to the url
       */

      var created_tv_var = this.createTvVariable(variation_chosen);
      if (window.debugMTS === "1") {
        console.log('xxx=created_tv_var2:', created_tv_var);
      }

      /*
          If we need to edit the base url as opposed to just the url parameters, then do it here
       */

      if (this.addPathsToUrl) {
        // console.log('xxx- addPathsToUrl',this.addPathsToUrl);
        //check if we have a specific pre set path for "TV" variable and if so add the specified path to the url
        if (this.added_base_paths.hasOwnProperty(variation_chosen)) {
          var dir_name = this.added_base_paths[variation_chosen];
          urlToLoad = this.addDirToURL(urlToLoad, dir_name);
          // console.log('xxx - about to add path ', urlToLoad);
          // console.log('xxx - new_url ', urlToLoad);
        }
      }

      //reload page with new TV variable in url
      if (queryStr !== '') {
        window.location = urlToLoad + "&tv=" + created_tv_var;
      } else {
        window.location = urlToLoad + "?tv=" + created_tv_var;
      }
      return;
    }

    /*
        Produces the winning variation based on the percentages given
        returns the winner as a string
        Allows one decimal ie 10.5% chance of winning (10.5)
          returns: (string/bool), the winning variation ie. 'ex1' or returns false if no variation was chosen
     */
  }, {
    key: "getWinningVariation",
    value: function getWinningVariation() {
      var _self = this;

      // console.log('in getWinningVariation22 -- existing _self.winning_variation: ',_self.winning_variation);

      if (_self.winning_variation !== undefined) return _self.winning_variation;

      //get random number between 1 and 1000
      var winning_num = Math.floor(Math.random() * 1000) + 1;
      if (window.debugMTS === "1") console.log('Calculating winning num.....Winning num:', winning_num);

      //generate ranges for each variable to win based
      var range = {};
      var starting_val = 0;
      var current_max_range;
      _self.winning_variation = false;
      for (var _i2 = 0, _Object$entries2 = Object.entries(this.trafficPercentagePerVariation); _i2 < _Object$entries2.length; _i2++) {
        var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
          key = _Object$entries2$_i[0],
          value = _Object$entries2$_i[1];
        current_max_range = 0;
        current_max_range = value + starting_val;
        range[key] = {
          'min': starting_val * 10 + 1,
          'max': current_max_range * 10
        };
        starting_val = current_max_range;
        if (winning_num >= range[key]['min'] && winning_num <= range[key]['max']) {
          if (window.debugMTS === "1") console.log("Winning number is ".concat(winning_num, " so winning test is '").concat(key, "'"));
          _self.winning_variation = key;
        }
        if (window.debugMTS === "1") console.log("".concat(key, ": ").concat(value, " --- min: ").concat(range[key]['min'], " ---- max: ").concat(range[key]['max']));
      }

      // console.log('_self.winning_variation set in func:',_self.winning_variation)

      return _self.winning_variation;
    }

    /*
        Removes 'tv' test var from url. Usually if there is an existing test var and it doesnt match the one we need
        or if there is a previoud test var and there shouldnt be one
     */
  }, {
    key: "removeExistingTestVar",
    value: function removeExistingTestVar() {
      if (window.debugMTS === "1") {
        console.log('xxx- removeExistingTestVar - removing tv variable, url:', window.location.href);
      }
      var newUrl = removeParam('tv', window.location.href);
      if (window.debugMTS === "1") {
        console.log('xxx- new url:', newUrl);
      }
      // throw new Error();
      window.location = newUrl;
      return;
    }

    /*
        Add a directory to a url
        So metaspoon.com/article_name
        would turn into
        metaspoon.com/{dir_name}/article_name
          url: (string), the url we want to add a dir name to
        dir_name: (string), the name of the directory we want to add to url
          returns: (string), the url with added dir name
     */
  }, {
    key: "addDirToURL",
    value: function addDirToURL(url, dir_name) {
      // console.log('xxx url:',url)
      // console.log('xxx dir_name:',dir_name)
      var divided_url = new URL(url);
      // console.log('xxx divided_url:',divided_url)

      var rebuilt_url = divided_url.origin + '/' + dir_name + divided_url.pathname + divided_url.search;
      return rebuilt_url;
    }

    /*
        Checks if the current tv var matches current platform/device and one of the current variables
          returns: (bool), true if it found a match, meaning current tv code fits current platform/device and experiment vars, and false if it does not
     */
  }, {
    key: "doesCurrentTvCodeMatch",
    value: function doesCurrentTvCodeMatch(tv) {
      for (var abVar in this.variations) {
        if (window.debugMTS === "1") {
          console.log('abVar:', abVar);
        }
        if (this.createTvVariable(this.variations[abVar]) === tv) return true;
      }
      return false;
    }

    /*
        Create tv variable based on user choices.
        Its formatted as "device-platform-variation_name"
        but if any of those are not specified then it wont show up in var name.
          variation_chosen: (string), the variation of the experiement chosen
          returns: (string), the variable to set for tv= in url
     */
  }, {
    key: "createTvVariable",
    value: function createTvVariable(variation_chosen) {
      var tv_var = '';
      if (this.testSpecificDevices === true) tv_var += "".concat(this.device, "-");
      if (this.testSpecificPlatforms === true) tv_var += "".concat(this.platformFromFbVar, "-");
      tv_var += variation_chosen;
      return tv_var;
    }

    /*
        Test if current conditions match the experiment's conditions
     */
  }, {
    key: "runTestConditions",
    value: function runTestConditions() {
      // console.log('xxx- (this.testAtLongFormOnly === this.currentIsLongform) :',(this.testAtLongFormOnly === this.currentIsLongform) )
      // console.log('xxx- this.devicesToTest.includes(device):',this.devicesToTest.includes(device))
      // console.log('xxx- (this.testSpecificPlatforms === this.platformsToTest.includes(platformFromFbVar)):',(this.testSpecificPlatforms === this.platformsToTest.includes(platformFromFbVar)))
      // console.log('xxx- (this.testAtCampaignLevel === this.campaignstoTest.includes(this.currentCampaign))"',(this.testAtCampaignLevel === this.campaignstoTest.includes(this.currentCampaign)))
      // console.log('xxx - typeof(this.params.tv) === \'undefined\':',typeof(this.params.tv) === 'undefined');

      //test all conditions and if they match then load test
      if ((this.currentIsLongform || !this.testAtLongFormOnly) && (
      //check if we are testing only long form and if current article is long form
      this.devicesToTest.includes(device) || !this.testSpecificDevices) && (
      //current device matches test criteria
      this.platformsToTest.includes(platformFromFbVar) || !this.testSpecificPlatforms) && (
      //check if we are testing for specific platforms and if current platform matches test criteria
      this.campaignstoTest.includes(this.currentCampaign) || !this.testAtCampaignLevel) //check if we are testing specific campaigns and if so if current campaign matches
      ) {
        //load campaign
        return true;
      }
      if (window.debugMTS === "1") {
        console.log('xxx-Experiment creator not going to run');
      }
      return false;
    }
  }, {
    key: "escapeHtml",
    value: function escapeHtml(string) {
      return String(string).replace(/[&<>"'\/]/g, function (s) {
        return entityMap[s];
      });
    }

    /*
        Sets all parameters in url to this.setParams class variable
     */
  }, {
    key: "setParams",
    value: function setParams() {
      this.params = {};
      if (location.search) {
        var parts = location.search.substring(1).split('&');
        for (var i = 0; i < parts.length; i++) {
          var nv = parts[i].split('=');
          if (!nv[0]) continue;
          this.params[nv[0]] = nv[1] || true;
        }
      }
    }

    /*
        This function checks if the current article is a long form article (by checking that "wd1" is in URL and if fb= url paramenter has anything in it
        meaning that it should show ads.
          returns: (bool), true if its a long form article with wd1 in url and false otherwise
     */
  }, {
    key: "isLongFormWithFB",
    value: function isLongFormWithFB() {
      /*
      This function checks if the current article is a long form article (by checking that "wd1" is in URL and if fb= url paramenter has anything in it
      meaning that it should show ads.
         */

      var fURL = encodeURI(window.location.href).toLowerCase();
      var fb = typeof this.params.fb !== 'undefined' ? this.params.fb.toLowerCase() : '';
      var lf;
      if (fURL.indexOf("wd1") !== -1) {
        // console.log('!!! - found wd1');
        lf = true;
      } else {
        lf = false;
      }
      if (lf === true) {
        //now check if fb  is blank
        if (fb != null) {
          return true;
        } else {
          return false;
        }
      }
    }
  }]);
}(); //instantiate object and call class
var test_status = "off";
console.log('Test is:', test_status);
if (test_status === "on") {
  var abTest = new runABTest();
}

/*
    All functions related to the API
 */

/*
    When the user calls this function it will return the country,etc
    api values. First it will check if they are already saved in the
    global variable, and if they will return it. Otherwise it will
    pull it form the api and save it as a global variable an return it.
 */
window.getApiData = function () {
  return new Promise(function (resolve, reject) {
    //check if function has already been called and if so check if api
    //data is available, if its not yet available then wait for first
    //call if function to complete to get the values from variable
    //
    //Problem: this is a solution to the problem in which this variable
    //is called a bunch of times at the same time, so we want to wait for the
    //first function to complete and then we can get the value from the variable

    var waitingForOtherFunctionToGetValue = window.ms_api_ran === true && !window.ms_api_data;

    //if the function was already called but we dont have the
    //data yet it means we are still pulling from the api, so we should
    //wait for it to be done and use that data
    if (waitingForOtherFunctionToGetValue) {
      resolve(_runIntervalCheckForData());
    } else {
      //if its the first time running the function we set this value to true
      //to prevent every call of the function from trying to pull from the api
      //as we only want to run it once
      if (!window.ms_api_ran) {
        window.ms_api_ran = true;
      }

      //first check if api data is available already
      // if its not then update data
      if (!window.ms_api_data) {
        _apiGetData().then(function (response) {
          window.ms_api_data = response;
          resolve(window.ms_api_data);
        });
      } //if its already been pulled then return that api data directly
      else {
        resolve(window.ms_api_data);
      }
    }
  });
};

/*
    Checks if the global window variables data from api 'window.ms_api_data' has been set
    as we wait for other ajax call to set the value. If we dont get the value it will keep
    running for X amount if times waiting Y amount of time in between tries

    Will check at intervals to see if data has been saved to javascript

    returns: (promise with resolve) - contains json with api request
 */
function _runIntervalCheckForData() {
  var ms_to_wait = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
  var num_tries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
  return new Promise(function (resolve, reject) {
    var interval;
    var count = 0;
    //check if data is set, and if its not then go into the interval
    if (window.ms_api_data) {
      resolve(interval = window.ms_api_data);
    } else {
      interval = setInterval(checkDataIsSetAndSend, ms_to_wait);
    }

    /*
        Callback function for interval.
        Will stop interval if 10 tries or a value is returned.
     */
    function checkDataIsSetAndSend() {
      count++;
      if (window.ms_api_data) {
        // console.log('checking on query again');
        clearInterval(interval);
        resolve(window.ms_api_data);
      }
      if (count > num_tries) {
        clearInterval(interval);
        reject('123 - Error: too many tries - giving up on ajax call API data!');
      }
    }
  });
}

/*
    Fetches country data from api and returns a promise to be async.
    Should NOT be called directly! Use M
 */
var _apiGetData = function _apiGetData() {
  return new Promise(function (resolve, reject) {
    var fvisit; //1 - means its probably bot , 2- means its normal user

    //set gdpr variable as if it were in eu by setting param "test_eu=1" in url
    var test_eu = parseInt(getParameterByName('test_eu')) === 1 ? "&test_eu=true" : '';
    var randc = Math.floor(Math.random() * 100000);
    var params = new FormData();
    params.append('action', 'get_user_data');

    //do ajax query to log in
    fetch(ajaxurl, {
      method: 'POST',
      body: params
    }).then(function (res) {
      return res.json();
    })["catch"](function (error) {
      // this.resetMessages();
    }).then(function (response) {
      var _ref;
      //if cant get data then send reject message

      var success = (_ref = typeof response !== 'undefined' && typeof response.isSuccess !== 'undefined') !== null && _ref !== void 0 ? _ref : false;
      if (success !== true) {
        reject('123-Can\'t connect to API');
      }

      //if succesful then return resolved response
      resolve(response);
    });

    // fetch("/wp-json/metaspoon/eu/get_cf_ipcountry?rand=" + randc + test_eu)
    //     .then(function (response) {
    //         return response.json();
    //     })
    //     .then(function (response) {
    //         // console.log('response was:',response);
    //         // console.log('response.data.isSuccess:',response.isSuccess);
    //         if(response.isSuccess !== true){
    //             reject('123-Can\'t connect to API');
    //         }
    //
    //         resolve(response);
    //
    //
    //     });
  });
};

/*
    Loads Google Analytics code
 */

window.initializeAnalytics = function () {
  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date();
    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');

  /*
      Make sure current_domain_gooanalytics exists, so we dont get a breaking js error
   */
  if (typeof current_domain_gooanalytics !== 'undefined') {
    var _current_domain_gooan, _current_domain_gooan2, _current_domain_gooan3;
    var current_domain_gooanalytics_0 = (_current_domain_gooan = current_domain_gooanalytics[0]) !== null && _current_domain_gooan !== void 0 ? _current_domain_gooan : 'error getting current_domain_gooanalytics[0]';
    var current_domain_gooanalytics_1 = (_current_domain_gooan2 = current_domain_gooanalytics[1]) !== null && _current_domain_gooan2 !== void 0 ? _current_domain_gooan2 : 'error getting current_domain_gooanalytics[1]';
    var current_domain_gooanalytics_2 = (_current_domain_gooan3 = current_domain_gooanalytics[2]) !== null && _current_domain_gooan3 !== void 0 ? _current_domain_gooan3 : 'error getting current_domain_gooanalytics[2]';
    ga('create', 'UA-54025216-1', 'auto');
    ga('create', current_domain_gooanalytics_0, {
      'name': current_domain_gooanalytics_1
    });
    ga('set', 'anonymizeIp', true);
    ga(current_domain_gooanalytics_2, 'pageview');
  } else {
    ga('create', 'UA-54025216-1', 'auto');
    ga('set', 'anonymizeIp', true);
  }
};
initializeAnalytics();
/*
    Detects if page is being loaded in an iframe
 */
/*
function inIframe() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

if (inIframe() === true) {
    ga('send', 'event', 'loadedInIframe', window.location.href, window.location.href);
    ga('metaspooncom.send', 'event', 'loadedInIframe', window.location.href, window.location.href);
}
*/
/*
    This section sets various variables and runs functions
    based on the results from the api
 */

getApiData().then(function (response) {
  //set value for fvisit to determine if use is a potential bot or not
  // fvisit = 1 represents bot and fvisit = 2 represents normal user
  window.fvisit = response.data.f;

  //send variables to google analytics
  var dimensionValue = response.data.xu;
  window.xu = dimensionValue;
  var ag = navigator.userAgent.toLowerCase();
  ga('set', 'dimension1', dimensionValue);
  ga('set', 'dimension2', dimensionValue);
  ga('set', 'dimension3', ag);
  ga('send', 'pageview');

  //if user is a bot then add it to the list on google analytics - used to create block list
  if (fvisit == 1) {
    ga('metaspooncom.send', 'event', 'fvisit1: ' + dimensionValue + ' - ' + window.location.href);
  }

  //if user is not a bot then load all the ads
  //NOTE: this should be managed eventually in lads.js as part of the normal ads
  domReady(function () {
    if (fvisit === 2) {

      //initialize AY Prebid Tracking System -- need to do it here if we want to track IPs
      // if (typeof window.initializeAY !== "undefined") {
      //     // safe to use the function
      //     window.initializeAY();
      // }

      //initialize ad system --- WE LOAD THIS DIRECTLY NOW, WE DONT WAIT
      // const ad_sys = new AdSystem();
    }
  });
});
/*
    Contains newsletter class with all functionality
 */

console.log('MTS NEWSLETTER LOADED!!!!');
window.MtsNewsletter = /*#__PURE__*/function () {
  function _class() {
    _classCallCheck(this, _class);
  }
  return _createClass(_class, [{
    key: "displayNewsletterSignupModal",
    value:
    /*
        Displays the metaspoon newsletter sign up form
          callback: (function), run this function after newsletter
          returns: (obj), contains modal data
     */
    function displayNewsletterSignupModal(callback) {
      console.log('displayNewsletterSignupModal');
      var _self = this;

      //get the user's email and then launch the modal once we have it by using a callback function
      this.ajaxGetUserEmail(function (email) {
        console.log('running callback function');
        //
        // console.log('in callback - email:',email)

        var title = 'Metaspoon Newsletter';
        var content = _self.getNewsletterSignupContent(email);
        var modal_id = 'registerToNewsletterModal';
        window.mtsLaunchModal(modal_id, content, title);

        //set event listeners for newsletter registration modal
        _self.setEventListeners();
      });
    }

    /*
        Set action when users interact with newsletter registrations
     */
  }, {
    key: "setEventListeners",
    value: function setEventListeners() {
      var _self = this;
      console.log('In setEventListeners for newsletter registration');

      /*
           Action when user clicks on "Register to newsletter"
        */
      _self.register_button = $('#mts-modal-newsletter-submit-email');
      _self.skipNewsletterRegistrationButton = $('#skipNewsletterRegistrationButton');
      _self.closeNewsletterRegistrationModal = $('#closeNewsletterRegistrationModal');
      _self.mtsNewsletterRegistrationUnsuscribeText = $('#mts-newsletter-registration-unsuscribe-text');
      if (_self.register_button.attr('init') !== '1') {
        //check that button hasnt already been initialized so we dont double initialize by mistake
        _self.register_button.attr('init', '1'); //add attribute init = 1 so we know its already been initialized

        _self.register_button.click(function (e) {
          console.log('clicked on registration button!');
          e.preventDefault();

          //grab div for status
          _self.status = document.querySelector('#mts-newsletter-registration-status-message');

          //set loading message
          _self.setLoadingMessage();

          //check if button is disabled, and if it is not, then continue
          if (_self.register_button.hasClass("disabled")) return;

          //get the email address from form
          _self.emailInput = jQuery('#mts_newsletter_registation_email_address');
          var email = _self.emailInput.val();
          console.log('email:', email);

          /*
              Run the ajax request to register user to newsletter
           */
          var params = new FormData();
          params.append('action', 'mts_newsletter_register');
          params.append('logged_in_nonce', logged_in_nonce);
          params.append('qip_general_nonce', qip_general_nonce);
          params.append('email', email);

          /*
              Do ajax query to get an array with votes for user for sopost
           */
          fetch(window.ajaxurl, {
            method: 'POST',
            body: params
          }).then(function (res) {
            return res.json();
          })["catch"](function (error) {
            if (window.debugMTS === "1") {
              console.log('error with submission - ', error);
            }
          }).then(function (response) {
            if (window.debugMTS === "1") {
              console.log('response:', response);
            }
            console.log('AJAX NEWSLETTER REGISTATION response:', response);
            if (response === 0 || !response.status) {
              /*
                  Check if user is logged in and if not then launch a warning
               */
              if (window.debugMTS === "1") {
                console.log('Error: ', response.message);
              }
            }

            //if response is 1
            if (response.status === 1) {
              //return user email
              console.log('SUCCESFULLY REGISTED!');
              _self.setStatus('You have succesfully registered! <b>Please check your email to confirm your subscription or you won\'t receive it!</b>', 'success');

              //remove subscribe button
              _self.register_button.addClass("d-none");
              //remove skip newsletter registration button
              _self.skipNewsletterRegistrationButton.addClass("d-none");
              //hide email input
              _self.emailInput.addClass("d-none");
              //show close button
              _self.closeNewsletterRegistrationModal.removeClass("d-none");
              //hide unsubscribe text message
              _self.mtsNewsletterRegistrationUnsuscribeText.addClass("d-none");
            } else {
              console.log('COULDNT REGISTER:', response.message);
              _self.setStatus("Error: ".concat(response.message), 'error');
            }
          }); //end ajax query
        });
      }
    }

    /*
        Ajax request to get email address for user from server if user exists
          callback: (function), what to run after we have the email address
     */
  }, {
    key: "ajaxGetUserEmail",
    value: function ajaxGetUserEmail() {
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
      // console.log('running ajaxGetUserEmail');

      /*
          Run the ajax request
       */
      var params = new FormData();
      params.append('action', 'mts_newsletter_get_user_email');
      params.append('logged_in_nonce', logged_in_nonce);

      /*
          Do ajax query to get an array with votes for user for sopost
       */
      fetch(window.ajaxurl, {
        method: 'POST',
        body: params
      }).then(function (res) {
        return res.json();
      })["catch"](function (error) {
        if (window.debugMTS === "1") {
          console.log('error with submission - ', error);
        }
      }).then(function (response) {
        if (window.debugMTS === "1") {
          console.log('response:', response);
        }

        // console.log('response:', response);

        if (response === 0 || !response.status) {
          /*
              Check if user is logged in and if not then launch a warning
           */
          if (window.debugMTS === "1") {
            console.log('Error: ', response.message);
          }
        }

        //if response is 1
        if (response.status === 1) {
          //return user email
          callback(response.email);
          return;
        }

        //if no success return blank email
        callback();
        return;
      }); //end ajax query
    }

    /*
        Returns the html for newsletter signup
          email: (string), the user's email address we will be using to sign up to newsletter
            returns: (string), html newsletter modal content
     */
  }, {
    key: "getNewsletterSignupContent",
    value: function getNewsletterSignupContent() {
      var email = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var content = "\n        \n        <h5 class=\"login-modal-newsletter-reg-title text-center\"><i class=\"fas fa-envelope mr-2\"></i>Subscribe to Metaspoon Digest, our email newsletter!</h5>\n        <form id=\"mts-newsletter-register\" class=\"form-signin\" action=\"#\" method=\"post\">\n        \n            <div class=\"mt-1 mb-3\">Get the latest and greatest Metaspoon stories delivered straight to your inbox.</div>\n        \n            <div class=\"form-label-group mb-1\">\n                <input id=\"mts_newsletter_registation_email_address\" name=\"user_login\" class=\"form-control\" placeholder=\"Email address\" value=\"".concat(email, "\" required autofocus>\n            </div>\n        \n        \n            <p class=\"mts-newsletter-registration-modal-status text-center mt-n3 mb-n1 d-none\" data-message=\"invalid-email\"></p>\n        \n            <button type=\"submit\" class=\"btn btn-lg btn-primary btn-block text-uppercase\" id=\"mts-modal-newsletter-submit-email\"><i class=\"fas fa-envelope mr-2\"></i>Subscribe!</button>\n            \n            <div id=\"mts-newsletter-registration-status-message\" class=\"alert d-none mt-2\" role=\"alert\"></div>\n            \n            <small class=\"form-text text-muted mb-3\" id=\"mts-newsletter-registration-unsuscribe-text\">You can unsubscribe and revoke your consent at any time at the bottom of the newsletter.</small>\n            \n\n        </form>\n        \n        \n\n        <div class=\"modal-footer\">\n            <button type=\"button\" class=\"btn btn-danger\" data-dismiss=\"modal\" id=\"skipNewsletterRegistrationButton\">SKIP</button> \n            <button type=\"button\" class=\"btn btn-success d-none\" data-dismiss=\"modal\" id=\"closeNewsletterRegistrationModal\">Close</button> \n        </div>");
      return content;
    }

    /*
        Sets a message in status
          message: (string), the message we want to set in status
        type: (string), the type of message, sets the font size/color/etc (success,error,loading)
     */
  }, {
    key: "setStatus",
    value: function setStatus(message) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "success";
      console.log('in set status, type:', type);
      //set warning background colour
      var css_class = '';
      if (type === 'success') css_class = 'alert-success';else if (type === 'error') css_class = 'alert-danger';else if (type === 'loading') css_class = 'alert-info';else css_class = 'what';
      console.log('selected css class ', css_class);
      this.resetMessages();
      this.status.classList.remove('d-none'); //make status div invisible again
      console.log('about to add css class:', css_class);
      this.status.classList.add(css_class);
      this.status.innerHTML = message;
    }

    /*
        Resets status message in modal
     */
  }, {
    key: "resetMessages",
    value: function resetMessages() {
      console.log('cleaning messages');
      this.status.innerHTML = '';
      this.status.classList.remove('alert-success', 'alert-danger', 'alert-info');
      this.status.classList.add('d-none'); //make status div invisible again
    }

    /*
        Shows loading message in status
     */
  }, {
    key: "setLoadingMessage",
    value: function setLoadingMessage() {
      console.log('in set loading message');
      this.setStatus('<div class="spinner-border text-primary spinner-border-sm mr-1"></div>Loading...', 'loading');
    }
  }]);
}();

/*
    AY facebook pixel firing events
 */

function getCookie(a) {
  a += "\x3d";
  var b = decodeURIComponent(document.cookie);
  b = b.split(";");
  for (var d = 0; d < b.length; d++) {
    for (var c = b[d]; " " == c.charAt(0);) c = c.substring(1);
    if (0 == c.indexOf(a)) return c.substring(a.length, c.length);
  }
  return "";
}
function setCookie(a, b) {
  var d = "";
  document.cookie = a + "\x3d" + (b || "") + d + "; path\x3d/";
}
var host = window.location.hostname,
  lastVV,
  lastSessionValue,
  sessionValue;

/*
    Only run purch if fb=40*** --- account 40
 */
var urlParamsB = new URLSearchParams(window.location.search);
var fb = urlParamsB.get('fb');
fb && console.log('!!! FB = ', fb.substring(0, 2));
if (fb && fb.substring(0, 2) === '40') {
  addEventListener("assertive_predictedRevenue", function (e) {
    if ((typeof fbq === "undefined" ? "undefined" : _typeof(fbq)) === undefined) return;
    // Purchase Pixel on every revenue event, revenue as CPM
    var transactionId = e.data.meta.impressionUUID;

    //see if winner is prebid or google
    var preBidWon = e.data.meta.preBidWon;
    var bidder = e.data.meta.highestPreBid_partner;
    if (e.data.meta.preBidWon === false) bidder = 'Google';

    //Send tracking pixel to facebook event
    fbq('track', 'Purchase', {
      content_type: "Product",
      content_ids: [e.data.meta.custom_2],
      currency: "CAD",
      bidder: e.data.meta.highestPreBid_partner,
      adUnit: e.data.meta.adUnitPath,
      value: e.data.predictedRevenueCPM.impression,
      impressionId: transactionId
    }, {
      eventID: transactionId
    });
    console.log('purchase tracking sent');

    // /*
    //     Create events based on 1 cent increments
    //  */
    // if(!window.mts_rps) window.mts_rps = 0;
    // if(!window.mts_rps_level) window.mts_rps_level = 'na';
    // let trigger_pixel = false;
    // window.mts_rps = window.mts_rps + (e.data.predictedRevenueCPM.impression/1000); //revenue in cents
    // if(window.mts_rps >= 0.01 && window.mts_rps_level == 'na') trigger_pixel = true;

    // console.log('e.data:', e.data);
    // console.log('content_ids:', [e.data.meta.custom_2]);
    // console.log('bidder:', e.data.meta.highestPreBid_partner);
    // console.log('adUnit:', e.data.meta.adUnitPath);
    // console.log('content_category:', e.data.predictedRevenueCPM);
    // console.log('impressionId:', transactionId);
    // console.log('bidder:', bidder);

    // original simple fb event
    /*
    fbq('track', 'Purchase', {
       currency: "CAD",
       value: e.data.predictedRevenueCPM.impression,
       transactionId: transactionId
    }, {eventID: transactionId});
    */

    // vv Custom Conversion Pixel on every full cent
    lastVV = Number(getCookie("lastVVValue")) || 0;
    lastSessionValue = Number(getCookie("lastSessionValue")) || 0;
    sessionValue = lastSessionValue + e.data.predictedRevenueCPM.impression;
    setCookie("lastSessionValue", sessionValue);
    var a = Math.round(Number(sessionValue / 10)) / 100;
    var cents = a * 100; //at cent level rather than dollar level
    console.log('---------------!!!!!!!! SESSION VALUE A:', a);
    console.log('---------------!!!!!!! lastSessionValue:', lastSessionValue);
    console.log('---------------!!!!!!! New impression:', e.data.predictedRevenueCPM.impression);
    console.log('---------------!!!!!!! lastVV:', lastVV);
    console.log('---------------!!!!!!! sessionValue - lastVV:', sessionValue - lastVV);
    console.log('---------------!!!!!!! bidder won:', bidder);
    10 < sessionValue - lastVV && (fbq("trackCustom", "vv", {
      value: cents,
      currency: "CAD"
    }, {
      eventID: "vv" + transactionId
    }), setCookie("lastVVValue", sessionValue));
  }, !1);
}

},{}]},{},[1]);
